import React from 'react'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { setLoginPopupOpen } from '../../store/slices/uiSlice'
import { useUserRedux } from '../../hooks/useUserRedux'
import styles from './Header.module.css'

const UserIcon: React.FC = () => {
  const dispatch = useDispatch()
  const { isAuthenticated, isLoading, user } = useAuth()
  const { user: backendUser } = useUserRedux()

  const handleLoginClick = () => {
    dispatch(setLoginPopupOpen(true))
  }

  const getAvatarText = () => {
    // Prefer backend user data
    const firstName = backendUser?.personal?.firstName || ''
    const lastName = backendUser?.personal?.lastName || ''
    const email = backendUser?.contacts?.email || ''

    const firstInitial = firstName.trim().charAt(0)
    const lastInitial = lastName.trim().charAt(0)

    if (firstInitial && lastInitial) return `${firstInitial}${lastInitial}`.toUpperCase()
    if (firstInitial) return firstInitial.toUpperCase()

    // Fallbacks: email initial, then OAuth givenName, else 'U'
    const emailInitial = email.trim().charAt(0)
    if (emailInitial) return emailInitial.toUpperCase()
    if ((user as any)?.attributes?.givenName) {
      return (user as any).attributes.givenName.charAt(0).toUpperCase()
    }
    return 'U'
  }

  if (isLoading) {
    return (
      <button className={styles.userBtn} disabled>
        <span className={styles.userText}>...</span>
      </button>
    )
  }

  if (isAuthenticated) {
    return (
      <Link to="/account/profile" className={styles.userLoginBtn}>
        <div className={styles.userAvatar} aria-label="User avatar">
          {getAvatarText()}
        </div>
      </Link>
    )
  }

  return (
    <button className={styles.userBtn} onClick={handleLoginClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="17"
        viewBox="0 0 14 17"
        fill="none"
        className={styles.userIcon}
      >
        <ellipse
          cx="3.33333"
          cy="3.33333"
          rx="3.33333"
          ry="3.33333"
          transform="matrix(-1 0 0 1 10.333 1.5)"
          fill="#0D0D0D"
          stroke="#0D0D0D"
          strokeWidth="1.5"
        />
        <path
          d="M1.16699 13.1123C1.16699 12.3953 1.6177 11.7557 2.2929 11.5146V11.5146C5.33703 10.4274 8.66362 10.4274 11.7077 11.5146V11.5146C12.3829 11.7557 12.8337 12.3953 12.8337 13.1123V14.2085C12.8337 15.1981 11.9572 15.9582 10.9777 15.8182L10.651 15.7716C8.22952 15.4256 5.77112 15.4256 3.3496 15.7716L3.023 15.8182C2.04341 15.9582 1.16699 15.1981 1.16699 14.2085V13.1123Z"
          fill="#0D0D0D"
          stroke="#0D0D0D"
          strokeWidth="1.5"
        />
      </svg>
      <span className={styles.userText}>Увійти</span>
    </button>
  )
}

export default UserIcon
